"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var styles_1 = require("./styles");

var flex = require('@headspace/hs-web-style-guide/dist/flex').default;

var TabBar =
/** @class */
function (_super) {
  __extends(TabBar, _super);

  function TabBar(props) {
    var _this = _super.call(this, props) || this;

    _this.setActiveTab = function (idx) {
      _this.setState({
        activeIndex: idx
      });
    };

    _this.generateTabProps = function (tab, idx) {
      var isActive = idx === _this.state.activeIndex;

      var onTabClick = function onTabClick() {
        _this.setActiveTab(idx);

        _this.props.tabUpdateAction(tab);
      };

      return {
        isActive: isActive,
        onTabClick: onTabClick
      };
    };

    _this.generateTabs = function (tabInfo) {
      var tabs = [];
      var tabUnderlines = [];
      tabInfo.forEach(function (tab, idx) {
        var tabProps = _this.generateTabProps(tab, idx);

        tabs.push(React.createElement(Tab, {
          tabInfo: tab,
          key: idx,
          onClick: tabProps.onTabClick,
          isActive: tabProps.isActive
        }));
        var tabUnderlineStyle = tabProps.isActive ? __assign({}, styles_1.tabUnderline, styles_1.tabUnderlineActive) : __assign({}, styles_1.tabUnderline, styles_1.tabUnderlineInactive);
        tabUnderlines.push(React.createElement("div", __assign({}, tabUnderlineStyle, {
          key: tab.label,
          onClick: tabProps.onTabClick
        })));
      });
      return {
        tabs: tabs,
        tabUnderlines: tabUnderlines
      };
    };

    _this.state = {
      activeIndex: 0
    };
    return _this;
  }

  TabBar.prototype.render = function () {
    var tabs = this.generateTabs(this.props.tabs);
    return React.createElement("div", null, React.createElement("div", __assign({}, styles_1.tabBar, {
      className: "tabBar"
    }), React.createElement("ul", __assign({}, styles_1.tabList), tabs.tabs)), React.createElement("div", __assign({}, styles_1.tabBarUnderline), tabs.tabUnderlines));
  };

  return TabBar;
}(React.Component);

exports.TabBar = TabBar;

var Tab = function Tab(props) {
  var tabStyle = props.isActive ? __assign({}, styles_1.tab, styles_1.tabActive) : __assign({}, styles_1.tab);
  return React.createElement("li", __assign({}, tabStyle, {
    className: "tab",
    onClick: props.onClick
  }), props.tabInfo.label);
};